<template>
  <div class="modal fade createAdminModal" id="createAdminModal" tabindex="-1" role="dialog" aria-labelledby="createAdminModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form class="form-horizontal" @submit.prevent="createAdminUser">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ type === 'edit' ? 'Update Admin Details' : 'Create New Admin' }} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">First Name</label>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model.trim="adminUser.firstName">
                </div>
              </div>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Name</label>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model.trim="adminUser.lastName">
                </div>
              </div>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Email ID</label>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <input type="email" class="form-control" v-model.trim="adminUser.email">
                </div>
              </div>
              <template v-if="type !== 'edit'">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Password</label>
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <div class="form-group">
                    <input type="password" class="form-control" v-model.trim="adminUser.password">
                  </div>
                </div>
              </template>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Type</label>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <select class="form-control pull-left item-type p-0" id="type" v-model="adminUser.userType">
                    <option value="admin">admin</option>
                    <option value="manager">manager</option>
                  </select>
                </div>
              </div>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Department</label>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <select class="form-control pull-left item-type p-0" id="department" v-model="adminUser.department">
                    <option value="sales">Sales</option>
                    <option value="support">Support</option>
                  </select>
                </div>
              </div>
              <label :class="{'mt-12' : type === 'add'}" class="col-sm-2 col-md-2 col-lg-2 col-form-label">HB FullName</label>
              <div :class="{'mt-12' : type === 'add'}" class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model.trim="adminUser.hbName">
                </div>
              </div>
              <label :class="{'mt-12' : type === 'add'}" class="col-sm-2 col-md-2 col-lg-2 col-form-label">HB Tag Names</label>
              <div :class="{'mt-12' : type === 'add'}" class="col-sm-4 col-md-4 col-lg-4">
                <div class="d-flex">
                  <multi-select
                      type="text"
                      v-model="adminUser.hbTags"
                      tag-placeholder="Add tag"
                      placeholder="Add tags"
                      :options="adminUser.hbTags"
                      :option-height="3"
                      :multiple="true"
                      :taggable="true"
                      @tag="addTags"
                      openDirection="bottom"
                  >
                    <template slot="singleLabel" slot-scope="{ adminTags, remove }">
                      <input
                          type="text"
                          v-model="adminTags"
                      >
                      <span @click="remove(adminTags)">&times;</span>
                    </template>
                  </multi-select>
                </div>
              </div>
            </div>
            <Alert class="mt-4" :type="alert.type" :message="alert.message" v-if="alert.show === true"/>
            <!-- Section to show customer's account details END -->
<!--            <div class="row">-->
<!--              <label class="col-sm-2 col-form-label"></label>-->
<!--              <div class="col-sm-10">-->
<!--                <div class="form-group">-->
<!--                  <button type="submit" class="btn btn-warning">Create Admin User</button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn btn-secondary btn-sm ml-25"  data-dismiss="modal" aria-label="Close">Close</button>
            <button :disabled="loadingForCreate" type="submit" class="btn btn-warning">
              <div class="loader mini_loader" v-if="loadingForCreate"></div>
              <span v-else>Submit</span>
            </button>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
	import {db, auth} from "@/firebase/init";
  import multiSelect from "vue-multiselect";

	export default {
		name: "createAdminUser",
		components: {
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
      multiSelect
		},
		data() {
			return {
        alert: {
          type: '',
          message: '',
          show: false
        },
				adminUser: {
					firstName: null,
					lastName: null,
					email: null,
					password: null,
					userType: "admin",
          type: 'add',
          hbTags: []
				},
        adminTagsForModal: [],
        type: 'add',
        loadingForCreate: false
      };
		},
		computed: {
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			}
		},
    watch: {
      adminUser: {
        immediate: true,
        deep: true,
        handler(value) {
          if (value.email) {
            this.adminUser.email = value.email.toLowerCase()
          }
        }
      }
    },
		methods: {
      load(data) {
        console.log('135', data)
        this.alert = {show: false, message: '', type: ''}
        this.type = data.type;
        if(data.type === 'edit') {
          this.adminUser = JSON.parse(JSON.stringify(data))
          if(!this.adminUser.hbTags){
            this.adminUser.hbTags = []
          }
          console.log('139', this.adminUser)
        } else {
          this.adminTagsForModal = []
          this.adminUser = {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            userType: "admin",
            type: 'add',
            hbTags: []
          }
          console.log('148', this.adminUser)
        }
        $(`#createAdminModal`).modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
      },
      addTags (newID){
        this.adminUser.hbTags.push(newID);
      },
      async updateAdminDetails() {
        try {
          if(!this.adminUser.firstName || !this.adminUser.lastName || !this.adminUser.email) {

            this.alert = { type: 'danger', message: 'Please fill up ALL the fields.', show: true}

            setTimeout(() => {
              // this.$store.dispatch("alert/showUpdate", {show: false});
              this.alert = { type: 'danger', message: 'Please fill up ALL the fields.', show: false}
            }, 5000);
            return
          }
          console.log('inside ')
          this.loadingForCreate = true;
          await this.$http.post("/auth/update-user-email", {
            uid: this.adminUser.docID,
            newEmail: this.adminUser.email,
            grant_type: 'token',
          })
          await db.collection('users').doc(this.adminUser.docID).update({...this.adminUser})
          this.loadingForCreate=false
          this.adminTagsForModal = []
          this.$emit('refreshAdmin', {success: true, msg: "Admin details have been updated successfully."})
          $(`#createAdminModal`).modal('hide');

        } catch (e) {
          this.loadingForCreate = false
          this.alert = { type: 'danger', message: e.toString(), show: true}
          console.log('206', e.toString())
        } finally {
        }
      },
			createAdminUser() {
				// Check if all fields are filled up properly
        if(this.type === 'edit') {
          this.updateAdminDetails()
          return true;
        }
				if (
					this.adminUser.firstName &&
					this.adminUser.lastName &&
					this.adminUser.email &&
					this.adminUser.password
				) {
					// Set asyncDone to true
          this.loadingForCreate=true
					// Create the user using firebase auth and store the additional data in firestore
					auth
						.createUserWithEmailAndPassword(
							this.adminUser.email,
							this.adminUser.password
						).then(credential => {
							db
								.collection("users")
								.doc(credential.user.uid)
								.set({
									firstName: this.adminUser.firstName,
									lastName: this.adminUser.lastName,
									email: this.adminUser.email,
									userType: this.adminUser.userType,
                  createdAt: Date.now(),
                  updatedAt: Date.now()
								})
								.then(() => {
									// Set asyncDone to true
                  this.addLog({
                    message: `New admin of ${this.adminUser.userType} type has been created. Email: ${this.adminUser.email}`,
                    level: "info"
                  })
									// Show success message to the admin for 5 sec
									// this.$store.dispatch("alert/update", {
									// 	type: "success",
									// 	message: `Admin user for ${this.adminUser.firstName} ${
									// 		this.adminUser.lastName
									// 		} (${this.adminUser.email}) has been created successfully.`,
									// 	show: true
									// });
                  // this.alert = { type: 'success', message: `Admin user for ${this.adminUser.firstName} ${
                  //       this.adminUser.lastName
                  //   } (${this.adminUser.email}) has been created successfully.`, show: true}
                  this.loadingForCreate=false
                  this.$emit('refreshAdmin', {success: true, msg: `Admin user for ${this.adminUser.firstName} ${
                        this.adminUser.lastName
                    } (${this.adminUser.email}) has been created successfully.` })
                  $(`#createAdminModal`).modal('hide');
                  // setTimeout(() => {
                  //   this.adminUser = {
									// 		firstName: null,
									// 		lastName: null,
									// 		email: null,
									// 		password: null,
									// 		userType: "admin"
									// 	};
									// }, 5000);
								})
								.catch(err => {
                  this.loadingForCreate=false
                  // Set asyncDone to true

									// Show error message to the admin for 5 sec
                  this.alert = { type: 'danger', message: err.message, show: true}
                  this.addLog({
                    message: err.message,
                    level: "danger"
                  })
									setTimeout(() => {
                    this.alert = { type: 'danger', message: err.message, show: false}
                  }, 5000);
								}).finally(() =>{
                   this.loadingForCreate = false
              });
						})
						.catch(err => {
							/// Set asyncDone to true
              console.log('line 210')
							// Show error message to the admin for 5 sec
              this.alert = { type: 'danger', message: err.message, show: true}
              this.addLog({
                message: err.message,
                level: "danger"
              })
							setTimeout(() => {
                this.alert = { type: 'danger', message: err.message, show: false}
							}, 5000);
						}).finally(() => {
            this.loadingForCreate = false
          });
				} else {
					// Show error message to the admin for 5 sec
					// this.$store.dispatch("alert/update", {
					// 	type: "danger",
					// 	message: "Please fill up ALL the fields below.",
					// 	show: true
					// });
          this.alert = { type: 'danger', message: 'Please fill up ALL the fields.', show: true}

					setTimeout(() => {
						// this.$store.dispatch("alert/showUpdate", {show: false});
            this.alert = { type: 'danger', message: 'Please fill up ALL the fields.', show: false}
          }, 5000);
				}
			}
		}
	};
</script>
